// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SJHi","colBig":"styles_colBig__3rZxm","colSmall":"styles_colSmall__3V_WV"};